import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid,
  Tooltip, Legend, ResponsiveContainer
} from 'recharts';

const SERVICE_COLORS = [
  '#1976d2', '#388e3c', '#f57c00', '#d32f2f',
  '#7b1fa2', '#0097a7', '#e64a19', '#455a64'
];

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  const total = payload.reduce((sum, e) => sum + (e.value || 0), 0);
  const nonZero = payload.filter(e => e.value > 0);
  return (
    <Paper sx={{ p: 1, border: '1px solid #ccc', maxWidth: 300 }}>
      <Typography variant="body2" fontWeight="bold" mb={0.5}>{label}</Typography>
      {nonZero.map((entry, i) => (
        <div key={i} style={{ color: entry.color, fontSize: 11 }}>
          {entry.name.length > 32 ? `${entry.name.slice(0, 32)}…` : entry.name}: {entry.value}
        </div>
      ))}
      <Typography variant="body2" fontWeight="bold" mt={0.5}>Total: {total}</Typography>
    </Paper>
  );
};

const SnykIncomingByMicroserviceChart = ({ data = [], serviceNames = [] }) => {
  if (!data.length || !serviceNames.length) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" height={320}>
        <Typography color="text.secondary">No data available</Typography>
      </Box>
    );
  }
  return (
    <ResponsiveContainer width="100%" height={320}>
      <BarChart data={data} margin={{ top: 10, right: 30, left: 0, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="period" tick={{ fontSize: 11 }} interval="preserveStartEnd" />
        <YAxis />
        <Tooltip content={<CustomTooltip />} />
        <Legend
          formatter={v => v.length > 28 ? `${v.slice(0, 28)}…` : v}
          wrapperStyle={{ fontSize: 11 }}
        />
        {serviceNames.map((name, i) => (
          <Bar
            key={name}
            dataKey={name}
            name={name}
            stackId="a"
            fill={SERVICE_COLORS[i % SERVICE_COLORS.length]}
          />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
};

export default SnykIncomingByMicroserviceChart;
